export default "__VITE_PUBLIC_ASSET__76f0103f__"